import { navigate } from "wouter/use-browser-location";

const ACTIVE_SESSION_STORAGE_KEY = "l9-active-session-id";

/** Return from a standalone surface to the most recently opened conversation. */
export function goBackToConversation() {
  let sessionId: string | null = null;

  if (typeof window !== "undefined") {
    try {
      sessionId = window.localStorage.getItem(ACTIVE_SESSION_STORAGE_KEY);
    } catch {
      // Ignore unavailable browser storage and fall back to the chat landing.
    }
  }

  navigate(sessionId ? `/session/${sessionId}` : "/");
}
